import { render } from "./FacturacionElectronica.vue?vue&type=template&id=f0c81672"
import script from "./FacturacionElectronica.vue?vue&type=script&lang=js"
export * from "./FacturacionElectronica.vue?vue&type=script&lang=js"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__